import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';

const WelcomePopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleEnroll = () => {
    setIsOpen(false);
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full overflow-hidden animate-in fade-in zoom-in duration-300">
        <button
          onClick={() => setIsOpen(false)}
          className="absolute top-4 right-4 z-10 bg-white/90 hover:bg-white rounded-full p-2 shadow-lg transition-all duration-200 hover:scale-110"
        >
          <X className="w-5 h-5 text-gray-700" />
        </button>

        <div className="grid md:grid-cols-2 gap-0">
          {/* Image Section */}
          <div className="relative h-80 md:h-auto bg-white flex items-center justify-center p-6">
            <img
              src="https://customer-assets.emergentagent.com/job_98529d53-1c35-46ad-aba2-5200ea95c0d0/artifacts/7g164avx_WhatsApp%20Image%202026-02-04%20at%2019.03.41.jpeg"
              alt="ZOOM Academy"
              className="w-full h-auto object-contain"
            />
          </div>

          {/* Content Section */}
          <div className="p-8 flex flex-col justify-center">
            <div className="mb-6">
              <h2 className="text-3xl font-bold text-gray-900 mb-3">
                Welcome to<br />
                <span className="text-blue-600">ZOOM ACADEMY</span>
              </h2>
              <div className="w-16 h-1 bg-yellow-400 mb-4"></div>
              <p className="text-lg text-gray-700 italic font-medium mb-2">
                "Success is the sum of small efforts repeated every day."
              </p>
              <p className="text-sm text-gray-600">
                Your gateway to government & professional careers starts here!
              </p>
            </div>

            <div className="space-y-3">
              <Button
                onClick={handleEnroll}
                className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
              >
                Get Admission Details
              </Button>
              <p className="text-center text-sm text-gray-500">
                Limited seats available • Enroll now!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomePopup;
